import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    component: () => import("../views/Main.vue"),
    children: [
      {
        path: "main",
        name: "main",
        component: () => import("../views/Main.vue"),
      },
    ],
  },
  {
    path: "/info",
    component: () => import("../views/Info/Info.vue"),
    children: [
      {
        path: "",
        name: "info",
        component: () => import("../views/Info/Springsoft.vue"),
      },
      // {
      //   path: "business",
      //   component: () => import("../views/Info/Business.vue"),
      // },
      {
        path: "partnership",
        name: "partnership",
        component: () => import("../views/Info/Partnership.vue"),
      },
      {
        path: "map",
        name: "map",
        component: () => import("../views/Info/Map.vue"),
      },
    ],
  },
  {
    path: "/product",
    component: () => import("../views/Product/Happytable.vue"),
    children: [
      {
        path: "",
        component: () => import("../views/Product/HappytableInfo.vue"),
      },
      {
        path: "happybrain",
        component: () => import("../views/Product/Happybrain.vue"),
      },
      {
        path: "happytablet",
        component: () => import("../views/Product/Happytablet.vue"),
      },
      {
        path: "reference",
        component: () => import("../views/Product/Reference.vue"),
      },
      {
        path: "more",
        component: () => import("../views/Product/ReferenceMore.vue"),
      },
    ],
  },
  {
    path: "/content",
    component: () => import("../views/ContentTech/ContentMainPage.vue"),
  },
  {
    path: "/news",
    component: () => import("../views/News/News.vue"),
  },
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0};
    }
  },
});

export default router;
